import { useState } from "react";
import { Button, Col } from "reactstrap";
import { ClickOut } from "../../../../../constants";
import CommonThemeModalTitle from "../common/CommonThemeModalTitle";
import CustomModal3Body from "./CustomModal3Body";
import { dynamicImage } from "../../../../../utils";
import { Image } from "../../../../../coreComponents/Image";

const CustomModal3 = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Col xl="4" md="6" className="text-center">
      <div className="card-wrapper border rounded-3 h-100">
        <div>
          <CommonThemeModalTitle heading="Modal 3 -" subHeading="Balance Modal" text="Example of aria dashboard balance card." />
          <div className="overflow-hidden balance-modal">
            <Image className="img-fluid" src={dynamicImage(`alert/balance.png`)} alt="balance" />
            <Button color="primary" className="mx-auto mt-3" onClick={toggle}>
              {ClickOut}
            </Button>
          </div>
          <CustomModal3Body modal={modal} toggle={toggle} />
        </div>
      </div>
    </Col>
  );
};
export default CustomModal3;
